<template>
	<svg
		width="164px"
		height="77px"
		viewBox="0 0 164 77"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g transform="translate(-639.000000, -297.000000)">
				<g transform="translate(474.000000, 237.000000)">
					<g transform="translate(165.000000, 60.000000)">
						<path
							d="M157.125749,2.40625 C160.922293,2.40625 164,5.49455249 164,9.30416667 C164,13.1137808 160.922293,16.2020833 157.125749,16.2020833 L117.844311,16.2020833 C121.640856,16.2020833 124.718563,19.2903858 124.718563,23.1 C124.718563,26.9096142 121.640856,29.9979167 117.844311,29.9979167 L139.449102,29.9979167 C143.245646,29.9979167 146.323353,33.0862192 146.323353,36.8958333 C146.323353,40.7054475 143.245646,43.79375 139.449102,43.79375 L129.457954,43.79375 C124.671007,43.79375 120.790419,46.8820525 120.790419,50.6916667 C120.790419,53.2314095 122.754491,55.530715 126.682635,57.5895833 C130.479179,57.5895833 133.556886,60.6778858 133.556886,64.4875 C133.556886,68.2971142 130.479179,71.3854167 126.682635,71.3854167 L45.1736527,71.3854167 C41.3771084,71.3854167 38.2994012,68.2971142 38.2994012,64.4875 C38.2994012,60.6778858 41.3771084,57.5895833 45.1736527,57.5895833 L6.8742515,57.5895833 C3.07770723,57.5895833 0,54.5012808 0,50.6916667 C0,46.8820525 3.07770723,43.79375 6.8742515,43.79375 L46.1556886,43.79375 C49.9522329,43.79375 53.0299401,40.7054475 53.0299401,36.8958333 C53.0299401,33.0862192 49.9522329,29.9979167 46.1556886,29.9979167 L21.6047904,29.9979167 C17.8082462,29.9979167 14.7305389,26.9096142 14.7305389,23.1 C14.7305389,19.2903858 17.8082462,16.2020833 21.6047904,16.2020833 L60.8862275,16.2020833 C57.0896833,16.2020833 54.011976,13.1137808 54.011976,9.30416667 C54.011976,5.49455249 57.0896833,2.40625 60.8862275,2.40625 L157.125749,2.40625 Z M157.2,30.4791667 C160.955536,30.4791667 164,33.5315587 164,37.296875 C164,41.0621913 160.955536,44.1145833 157.2,44.1145833 C153.444464,44.1145833 150.4,41.0621913 150.4,37.296875 C150.4,33.5315587 153.444464,30.4791667 157.2,30.4791667 Z"
							fill="#F5F5F5"
						></path>
						<g transform="translate(48.000000, 0.000000)">
							<ellipse
								:stroke="color"
								stroke-width="4.8"
								fill="#FFFFFF"
								cx="38.4"
								cy="38.5"
								rx="36"
								ry="36.1"
							></ellipse>
							<g
								transform="translate(37.952000, 37.296875) scale(-1, 1) translate(-37.952000, -37.296875) translate(33.600000, 17.645833)"
								:fill="color"
								fill-rule="nonzero"
							>
								<path
									d="M8.704,34.890625 C8.704,37.3231031 6.7516928,39.3020833 4.352,39.3020833 C1.9523072,39.3020833 0,37.3231031 0,34.890625 C0,32.4581469 1.9523072,30.4791667 4.352,30.4791667 C6.7516928,30.4791667 8.704,32.4581469 8.704,34.890625 Z M0.721048241,2.17117849 L1.41286162,25.6070509 C1.44536667,26.7075891 1.98162377,27.5716146 2.63218269,27.5716146 L6.00680763,27.5716146 C6.65736654,27.5716146 7.19362365,26.7075891 7.2261287,25.6070509 L7.91794207,2.17117849 C7.95278709,0.989993286 7.39684382,0 6.698621,0 L1.94036931,0 C1.24214649,0 0.68620323,0.989993286 0.721048241,2.17117849 Z"
								></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ExclaimBackground',
	props: {
		color: {
			type: String,
			default: '#49A4DA',
		},
	},
}
</script>
